import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// Preset PrimeNG = Aura + couleur primaire orange (accent v0.7, dérivé de --color-accent #ea5b0c).
export const EuropaPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#fef1e8',
      100: '#fcd9c2',
      200: '#f9b98c',
      300: '#f59556',
      400: '#f2782f',
      500: '#ea5b0c', // = --color-accent
      600: '#d24f0a',
      700: '#b03f08',
      800: '#8e3207',
      900: '#6f2705',
      950: '#451803',
    },
  },
});
